import { createAction } from 'typesafe-actions';

import { SocialActions } from '../constants/Social';

export const loadFbSdkAndUpdateLoginStatus = createAction(
  SocialActions.LOAD_FB_SDK_AND_UPDATE_LOGIN_STATUS,
)();
export type LoadFbSdkAndUpdateLoginStatusAction = ReturnType<typeof loadFbSdkAndUpdateLoginStatus>;

export const loadFbSdkAndUpdatetokenValidity = createAction(
  SocialActions.LOAD_FB_SDK_AND_UPDATE_TOKEN_VALIDITY,
)();
export type LoadFbSdkAndUpdateTokenValidityAction = ReturnType<
  typeof loadFbSdkAndUpdatetokenValidity
>;

export const updateFacebookTokenValidity = createAction(
  SocialActions.UPDATE_FACEBOOK_TOKEN_VALIDITY,
)();
export type UpdateFacebookTokenValidityAction = ReturnType<typeof updateFacebookTokenValidity>;

interface SetFacebookTokenValidityPayload {
  listenerId: $TSFixMe;
  valid: $TSFixMe;
}

export const setFacebookTokenValidity = createAction(
  SocialActions.SET_FACEBOOK_TOKEN_VALIDITY,
  (listenerId: $TSFixMe, valid: $TSFixMe) => ({ listenerId, valid }),
)<SetFacebookTokenValidityPayload>();
export type SetFacebookTokenValidityAction = ReturnType<typeof setFacebookTokenValidity>;

export const checkFacebookConnectStatus = createAction(
  SocialActions.CHECK_FACEBOOK_CONNECT_STATUS,
)();
export type CheckFacebookConnectStatusAction = ReturnType<typeof checkFacebookConnectStatus>;

export const removeFacebookData = createAction(SocialActions.REMOVE_FACEBOOK_DATA)();
export type RemoveFacebookDataAction = ReturnType<typeof removeFacebookData>;
